<template>
  <div style="padding-bottom: 30px">
    <div class="fui-steps__wrap fui-steps__flex"
         style="padding: 0px; background: transparent;">
      <div class="fui-steps__node-wrap fui-steps__flex-col fui-steps__nw-col">
        <div class="fui-steps__node-box fui-steps__flex-row" style="height: 26px;">
          <div class="fui-steps__line fui-steps__line-row" style="background: transparent;">
          </div>
          <div class="fui-steps__node">
            <div v-if="stepNum === 1" class="fui-steps__checkbox fui-steps__background">
              <div class="fui-steps__checkmark"></div>
            </div>
            <div v-if="stepNum > 1" class="fui-steps__node-dot fui-steps__background"></div>
          </div>
          <div :class="['fui-steps__line','fui-steps__line-row',stepNum > 1 ? 'fui-steps__background' : '']"
               style="background: rgb(204, 204, 204);"></div>
        </div>
        <div class="fui-steps__content fui-steps__content-row"
             style="padding-bottom: 0px; padding-left: 10px;">
          <div class="fui-steps__title fui-steps__text-row fui-steps__color"
               style="font-size: 14px; font-weight: 400;"><span>选择系统</span></div>
        </div>
      </div>
      <div class="fui-steps__node-wrap fui-steps__flex-col fui-steps__nw-col">
        <div class="fui-steps__node-box fui-steps__flex-row" style="height: 26px;">
          <div :class="['fui-steps__line','fui-steps__line-row',stepNum > 1 ? 'fui-steps__background' : '']"
               style="background: rgb(204, 204, 204);"></div>
          <div class="fui-steps__node">
            <div v-if="stepNum === 2" class="fui-steps__checkbox fui-steps__background">
              <div class="fui-steps__checkmark"></div>
            </div>
            <div v-if="stepNum > 2" class="fui-steps__node-dot fui-steps__background"></div>
            <div v-if="stepNum < 2" class="fui-steps__node-dot"></div>
          </div>
          <div :class="['fui-steps__line','fui-steps__line-row',stepNum > 2 ? 'fui-steps__background' : '']"
               style="background: rgb(204, 204, 204);"></div>
        </div>
        <div class="fui-steps__content fui-steps__content-row"
             style="padding-bottom: 0px; padding-left: 10px;">
          <div :class="['fui-steps__title','fui-steps__text-row',stepNum >= 2 ? 'fui-steps__color' : '']"
               style="font-size: 14px; font-weight: 400;"><span>选择战区</span></div>
        </div>
      </div>
      <div class="fui-steps__node-wrap fui-steps__flex-col fui-steps__nw-col">
        <div class="fui-steps__node-box fui-steps__flex-row" style="height: 26px;">
          <div :class="['fui-steps__line','fui-steps__line-row',stepNum > 2 ? 'fui-steps__background' : '']"
               style="background: rgb(204, 204, 204);"></div>
          <div class="fui-steps__node">
            <div v-if="stepNum === 3" class="fui-steps__checkbox fui-steps__background">
              <div class="fui-steps__checkmark"></div>
            </div>
            <div v-if="stepNum < 3" class="fui-steps__node-dot"></div>
          </div>
          <div class="fui-steps__line fui-steps__line-row">
          </div>
        </div>
        <div class="fui-steps__content fui-steps__content-row"
             style="padding-bottom: 0px; padding-left: 10px;">
          <div :class="['fui-steps__title','fui-steps__text-row',stepNum >= 3 ? 'fui-steps__color' : '']"
               style="font-size: 14px; font-weight: 400;"><span>提交修改</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WarStep",
  props: ['stepNum']
}
</script>

<style scoped>
.fui-steps__flex {
  display: flex;
  flex-direction: row;
}

.fui-steps__wrap {
  width: 100%;
  box-sizing: border-box;
  flex-direction: inherit;
}

.fui-steps__flex-col {
  flex-direction: column;
}

.fui-steps__nw-col {
  flex: 1;
}

.fui-steps__node-wrap {
  position: relative;
  width: 100%;
  display: flex;
}

.fui-steps__node-box {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  overflow: hidden;
}

.fui-steps__flex-row {
  flex-direction: row;
  flex-shrink: 0;
}

.fui-steps__line-row {
  height: 1px;
  transform: scaleY(.5) translateZ(0);
}

.fui-steps__line {
  transform-origin: center;
  flex: 1;
}

.fui-steps__node {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.fui-steps__background {
  background: #465CFF !important;
}

.fui-steps__checkbox {
  width: 1.375rem;
  height: 1.375rem;
  display: inline-flex;
  box-sizing: border-box;
  border-radius: 50%;
  vertical-align: top;
  flex-shrink: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.fui-steps__checkmark {
  width: 0.6875rem;
  height: 1.375rem;
  border-bottom-style: solid;
  border-bottom-width: 3px;
  border-bottom-color: #fff;
  border-right-style: solid;
  border-right-width: 3px;
  border-right-color: #fff;
  transform: rotate(
      45deg) scale(.5);
  box-sizing: border-box;
  transform: rotate(
      45deg) scale(.5) translateZ(0);
  transform-origin: 54% 48%;
}

.fui-steps__content-row {
  flex-shrink: 0;
  word-break: break-all;
  padding: 0.375rem 0.625rem 0;
  align-items: center;
  overflow: hidden;
}

.fui-steps__content {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
}

.fui-steps__color {
  color: #465CFF !important;
}

.fui-steps__text-row {
  text-align: center;
}

.fui-steps__title, .fui-steps__descr {
  display: block;
  word-break: break-all;
  padding-bottom: 0.25rem;
  font-weight: 400;
}

.fui-steps__node-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #ccc;
}
</style>